import {
  SET_STEP,
  UPDATE_ORGANIZATION,
  UPDATE_PERSON,
  SET_REFERRAL,
  SET_MESSAGE,
  SET_SUBMITTING,
  SET_RESPONSE,
} from "./actions";

const initialState = {
  currentStep: 0,
  submitting: false,
  referral: "",
  message: "",
  organization: {
    name: "",
    type: "",
    size: "",
    other_type: "",
    pos_brand: "",
    country: "Deutschland",
    state: "",
  },
  person: {
    name: "",
    mayCall: true,
    phone: "",
    email: "",
    role: "",
    newsletterOptIn: false,
  },
  response: null,
  error: null,
};

const rootReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_STEP:
      return {
        ...state,
        currentStep: action.payload
      };
    case UPDATE_ORGANIZATION:
      return {
        ...state,
        organization: {
          ...state.organization,
          [action.payload.key]: action.payload.value
        }
      };
    case UPDATE_PERSON:
      return {
        ...state,
        person: {
          ...state.person,
          [action.payload.key]: action.payload.value
        }
      };
    case SET_REFERRAL:
      return {
        ...state,
        referral: action.payload
      };
    case SET_MESSAGE:
      return {
        ...state,
        message: action.payload
      };
    case SET_SUBMITTING:
      return {
        ...state,
        submitting: action.payload
      };
    case SET_RESPONSE:
      return {
        ...state,
        response: action.payload
      };
    default:
      return state;
  }
};

export default rootReducer;
